import * as api from '@gitbook/api-client';
import { Picker, type PickerItemData } from '@gitbook/react-uikit';
import { Description, FieldGroup, Group, Label } from '@gitbook/spine-react';

import { getPaidIndicatorBadgeProps, PaidFeatureIndicator } from '../../../../Components';
import { useSiteContext, useUpgradeSite } from '../../../../state';

export function VisibilityStatePublic(props: {
    disabled: boolean;
    formVisibility: api.SiteVisibility;
    targetVisibility: api.SiteVisibility;
    setVisibility: (value: api.SiteVisibility) => void;
}) {
    const { disabled = false, formVisibility, targetVisibility, setVisibility } = props;
    const { site } = useSiteContext();
    const upgrade = useUpgradeSite(site, api.SiteFeatureKey.SitesUnlistedVisibility);

    const state =
        targetVisibility === api.SiteVisibility.Public
            ? api.SiteVisibility.Public
            : api.SiteVisibility.Unlisted;

    const indexingPickerItems: PickerItemData<api.SiteVisibility>[] = [
        {
            value: api.SiteVisibility.Public,
            label: searchIndexing[api.SiteVisibility.Public].picker,
        },
        {
            value: api.SiteVisibility.Unlisted,
            label: searchIndexing[api.SiteVisibility.Unlisted].picker,
            upgrade: !!upgrade,
            badge: getPaidIndicatorBadgeProps({
                upgrade,
                isFeatureActive: formVisibility === api.SiteVisibility.Unlisted,
            }),
        },
    ];

    const handleVisibilityChange = (value: api.SiteVisibility) => {
        setVisibility(value);
    };

    return (
        <FieldGroup orientation="horizontal">
            <Group>
                <Group>
                    <Label>{searchIndexing[state].title} </Label>
                    <PaidFeatureIndicator
                        upgrade={upgrade}
                        isFeatureActive={state === api.SiteVisibility.Unlisted}
                    />
                </Group>
                <Description>
                    Choose whether your site will be indexed by search engines.
                </Description>
            </Group>
            <Picker
                items={indexingPickerItems}
                disabled={disabled}
                value={targetVisibility}
                onValueChange={handleVisibilityChange}
            />
        </FieldGroup>
    );
}

const searchIndexing = {
    [api.SiteVisibility.Public]: {
        title: 'Search engine indexing',
        picker: 'Index',
    },
    [api.SiteVisibility.Unlisted]: {
        title: 'No search engine indexing',
        picker: `Don't index`,
    },
};
